import { render, staticRenderFns } from "./health-insurance-companies.html?vue&type=template&id=44f21700&scoped=true&"
import script from "./health-insurance-companies.js?vue&type=script&lang=js&"
export * from "./health-insurance-companies.js?vue&type=script&lang=js&"
import style0 from "./health-insurance-companies.scss?vue&type=style&index=0&id=44f21700&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f21700",
  null
  
)

export default component.exports